module.exports = __webpack_public_path__ + "assets/img/653200.b1d344a8.png";